import React from 'react';
import CoarseType from './modelTypes/CoarseType';

function ConversionModelShelfStep2(props) {
    return <CoarseType {...props} />;
}

export default ConversionModelShelfStep2;
